module.exports = __webpack_public_path__ + "media/images/dpoint_horizontal-4cef9d76c525014abdd55cf5c2c3284d.png";